import { registerPlugin } from '@capacitor/core';

export interface AlarmKitPlugin {
  requestPermission(): Promise<{ granted: boolean; status: string }>;
  checkPermission(): Promise<{ granted: boolean; status: string }>;
  isAvailable(): Promise<{ available: boolean }>;
  scheduleAlarm(options: {
    id?: string;
    title: string;
    body?: string;
    triggerTime: number; // Unix timestamp in milliseconds
    activityUuid?: string;
  }): Promise<{ success: boolean; alarmId: string; scheduledFor: string }>;
  cancelAlarm(options: { id: string }): Promise<{ success: boolean }>;
  cancelAlarms(options: { ids: string[] }): Promise<{ cancelled: number }>;
  getScheduledAlarms(): Promise<{ alarms: Array<{ id: string; state: string }> }>;
}

const AlarmKit = registerPlugin<AlarmKitPlugin>('AlarmKit');

export default AlarmKit;
